// lambdaConfig.js
const lambdaConfig = {
    SecurityId: null,
    SecurityToken:null,
    EventContextId: null,
    CallerSourceId: null,
    CallerSourceName: null,
  };
  
  export default lambdaConfig;